import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';

import { StyledFieldSkeleton } from '../styled-common/styled.tsx';
import type { Props } from './types.tsx';

const FieldSkeleton = (): React.JSX.Element => (
	<div
		// eslint-disable-next-line jira/integration/enforce-data-testid-usage
		data-test-id="issue-create-commons.common.ui.loader.skeleton"
		data-testid="issue-create-commons.common.ui.loader.skeleton"
	>
		{/* eslint-disable-next-line @atlassian/a11y/label-has-associated-control -- See https://go/a11y-label-has-associated-control for more details */}
		<Label />
		<StyledFieldSkeleton />
		<Description />
	</div>
);

const IssueCreateLoader = ({ skeletonCount }: Props): React.JSX.Element => (
	<>
		{Array.from({ length: skeletonCount }, (_, index) => (
			<FieldSkeleton key={`field-skeleton-${index}`} />
		))}
	</>
);

export { FieldSkeleton };
export default IssueCreateLoader;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Label = styled(Skeleton)({
	height: token('space.250'),
	width: '120px',
	marginTop: token('space.250'),
	marginBottom: token('space.075'),
});

Label.displayName = 'LabelSkeleton';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled(Skeleton)({
	height: token('space.200'),
	width: '300px',
});

Description.displayName = 'DescriptionSkeleton';
